/**
 * lite-youtube-embed by Paul Irish
 * https://github.com/paulirish/lite-youtube-embed
 */
class LiteYTEmbed extends HTMLElement {
  connectedCallback() {
    this.videoId = this.getAttribute('videoid');

    let playBtnEl = this.querySelector('.lty-playbtn');
    this.playLabel = (playBtnEl && playBtnEl.textContent.trim()) || this.getAttribute('playlabel') || 'Play video';

    if (!this.style.backgroundImage && this.videoId) {
      this.style.backgroundImage = `url("https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg")`;
    }

    if (!playBtnEl) {
      playBtnEl = document.createElement('button');
      playBtnEl.type = 'button';
      playBtnEl.classList.add('lty-playbtn');
      this.append(playBtnEl);
    }
    if (!playBtnEl.textContent.trim()) {
      const playBtnLabelEl = document.createElement('span');
      playBtnLabelEl.className = 'lyt-visually-hidden';
      playBtnLabelEl.textContent = this.playLabel;
      playBtnEl.append(playBtnLabelEl);
    }
    playBtnEl.removeAttribute('href');

    this.addEventListener('pointerover', LiteYTEmbed.warmConnections, { once: true });
    this.addEventListener('focusin', LiteYTEmbed.warmConnections, { once: true });
    this.addEventListener('click', this.activate);
  }

  static addPrefetch(kind, url, as) {
    const linkEl = document.createElement('link');
    linkEl.rel = kind;
    linkEl.href = url;
    if (as) {
      linkEl.as = as;
    }
    document.head.append(linkEl);
  }

  static warmConnections() {
    if (LiteYTEmbed.preconnected) return;

    LiteYTEmbed.addPrefetch('preconnect', 'https://www.youtube-nocookie.com');
    LiteYTEmbed.addPrefetch('preconnect', 'https://www.google.com');
    LiteYTEmbed.addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
    LiteYTEmbed.addPrefetch('preconnect', 'https://static.doubleclick.net');

    LiteYTEmbed.preconnected = true;
  }

  activate = () => {
    if (this.classList.contains('lyt-activated') || !this.videoId) return;
    this.classList.add('lyt-activated');

    const params = new URLSearchParams(this.getAttribute('params') || '');
    params.set('autoplay', '1');
    params.set('playsinline', '1');

    const iframeEl = document.createElement('iframe');
    iframeEl.width = '560';
    iframeEl.height = '315';
    iframeEl.title = this.playLabel;
    iframeEl.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframeEl.allowFullscreen = true;
    iframeEl.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.videoId)}?${params.toString()}`;
    this.append(iframeEl);

    iframeEl.focus();
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('lite-youtube')) {
  customElements.define('lite-youtube', LiteYTEmbed);
}

export default LiteYTEmbed;
